import React, { Component } from 'react';
import css from './style.css';
import CSSModule from 'react-css-modules';

import TextFeild from '../textFeild';
//import RadioGroup from '../radioGroup';
import Validators from '../../utils/validator';
import Title from '../title';

import nameMap from '../../config/nameMap';
import { Radio } from 'antd';
const RadioGroup = Radio.Group;

var config = {
        'data': {
            'name' : [ 'notEmpty', {maxLength: 10}, 'isName'],
            'email':['notEmpty','isEmail'],
            'phoneNum':['notEmpty','isPhone'],
            'notification_type': ['notEmpty'],
            'gender': ['notEmpty']
        }
    }
let val = new Validators(config);	



class MemberData extends Component {
    constructor(props){
        super(props);
        this.state = {
            formData: props.userInfo || {},
            error: false
        }
        
        this.inputOnChange = (name, value) => {
            this.formValueOnChange(name, value);
        }

        this.radioSelect = (name, e) => {
            this.formValueOnChange(name, e.target.value);
        }

        this.onError = (name, errorMessage) => {
            this.setState({
                error: true
            })
        }
        this.getState = () => {
            return {
                ...this.state
            }
        }
    }
    
    componentWillReceiveProps(nextProps) {
        if( this.props.userInfo !== nextProps.userInfo ) {
            this.setState({ formData: nextProps.userInfo })
        }
    }
    
    formValueOnChange(name, value) {
        let formData = this.state.formData;
        formData[name] = value;
        this.setState({
            formData: formData,
            error: false
        });
    }
    renderInputBlock(blockArr) {

        return blockArr.map((key, index) => {
            return (
                <div styleName="block">
                    <p>{ nameMap[key] }</p>
                    <TextFeild 
                        styleName="input" 
                        value={this.state.formData[key]} 
                        type="text" 
                        name={key}
                        validator={val}
                        onError={this.onError} 
                        onChange={this.inputOnChange}/>
                </div>
            );
        }) 
    }
    renderRadioBlock(blockArr) {

        return blockArr.map((key, index) => {
            let group;
            if( key === 'gender' ) group = [{label: '男', value: 'male'}, {label: '女', value: 'female'}];
            else group = [{label: '電子郵件信箱', value: 'email'}, {label: '簡訊', value: 'sms'}];

            return (
                <div styleName="block">
                    <p>{ nameMap[key] }</p>
                    <RadioGroup onChange={this.radioSelect.bind(this, key)} value={this.state.formData[key]}>
                        <Radio value={group[0].value} > {group[0].label}</Radio>
                        <Radio value={group[1].value} > {group[1].label}</Radio>
                    </RadioGroup>
                </div>
            );
        }) 
    }
	render() {
        const { phoneNum, gender, notification_type, name, email } = this.state.formData;
        const title = this.props.firstTime ? '會員註冊' : '修改會員資料';
        //console.log(this.state.formData);
		return (
            <div className={ this.props.className }>
                <Title icon="people_c">{ title }</Title>
                <div styleName="form">
                    { this.renderInputBlock([
                        'phoneNum',
                        'name',
                        'email'
                    ])}
                    
                    { this.renderRadioBlock([
                        'notification_type',
                        'gender'
                    ]) }

                    { this.props.firstTime && this.renderInputBlock(['referrer_phoneNum']) }

                    { this.props.firstTime && <div>我們歡迎您與您的朋友一起來上課，填寫推薦人電話，在你第一次消費時，你與推薦人都可以獲得贈品點數 1 點，可以折抵 0.5 小時的體驗費用。</div>}
                    
                </div>
               
            </div>
		);
	}
}

export default CSSModule(MemberData,css);



/** WEBPACK FOOTER **
 ** ./src/component/memberData/index.js
 **/